import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Services from "./components/Services";
import Facilities from "./components/Facilities";
import Vacancies from "./components/Vacancies";
import FAQs from "./components/FAQs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App = () => (
  <>
    <a className="skip-link" href="#main-content">
      Skip to main content
    </a>
    <Navbar />
    <main id="main-content">
      <HeroSection />
      <About />
      <Services />
      <Facilities />
      <Vacancies />
      <FAQs />
      <Contact />
    </main>
    <Footer />
  </>
);

export default App;
